// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import TerceraRadioButtonComponentTemplate from '@front/templates/TerceraRadioButtonComponentTemplate.html';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { ContainerControl } from './ContainerControl';
export class TerceraRadioButtonComponent extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.TerceraRadioButtonComponent;
    }
    oninit() {
        super.oninit();
        this.on('radioBtnChange', this.onRbchange);
    }
    onRbchange(context, rindex) {
        const clickedItemIdx = rindex;
        const len = this.get('radioItems').length;
        for (let i = 0; i < len; i++) {
            void this.set('radioItems.' + i + '.checked', clickedItemIdx === i);
        }
        this.fire(RadioButtonComponentEvents.StateChange, clickedItemIdx);
    }
}
export var RadioButtonComponentEvents;
(function (RadioButtonComponentEvents) {
    RadioButtonComponentEvents["StateChange"] = "StateChange";
})(RadioButtonComponentEvents || (RadioButtonComponentEvents = {}));
ContainerControl.extendWith(TerceraRadioButtonComponent, {
    template: TerceraRadioButtonComponentTemplate,
    data: function () {
        return {
            radioItems: [],
            groupName: '',
            isHorisontal: false
        };
    }
});
